import { Heading, HeadingProps } from '@radix-ui/themes';

import styles from './Title.module.css';

export const Title = ({ children, ...rest }: HeadingProps) => {
    return (
        <Heading className={styles.title} as='h1' size={'5'} mb={'8'} {...rest}>
            {children}
        </Heading>
    );
};
